export default __webpack_public_path__ + "static/media/C_05_02_bg.a41515d3.mp4";